/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReviewDecision } from './ReviewDecision';
import {
    ReviewDecisionFromJSON,
    ReviewDecisionFromJSONTyped,
    ReviewDecisionToJSON,
    ReviewDecisionToJSONTyped,
} from './ReviewDecision';
import type { SubmissionResultStatus } from './SubmissionResultStatus';
import {
    SubmissionResultStatusFromJSON,
    SubmissionResultStatusFromJSONTyped,
    SubmissionResultStatusToJSON,
    SubmissionResultStatusToJSONTyped,
} from './SubmissionResultStatus';
import type { AcceptedBy } from './AcceptedBy';
import {
    AcceptedByFromJSON,
    AcceptedByFromJSONTyped,
    AcceptedByToJSON,
    AcceptedByToJSONTyped,
} from './AcceptedBy';

/**
 * 
 * @export
 * @interface SubmissionResultReadWithOutput
 */
export interface SubmissionResultReadWithOutput {
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    submission_id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    test_case_id: string;
    /**
     * 
     * @type {SubmissionResultStatus}
     * @memberof SubmissionResultReadWithOutput
     */
    status?: SubmissionResultStatus;
    /**
     * 
     * @type {number}
     * @memberof SubmissionResultReadWithOutput
     */
    points?: number | null;
    /**
     * 
     * @type {AcceptedBy}
     * @memberof SubmissionResultReadWithOutput
     */
    accepted_by?: AcceptedBy | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionResultReadWithOutput
     */
    near_match?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResultReadWithOutput
     */
    flagged_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    flag_comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    output_text: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    output_image_base64: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    diff_image_base64: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    error_text: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionResultReadWithOutput
     */
    mismatch?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    matched_output_id?: string | null;
    /**
     * 
     * @type {ReviewDecision}
     * @memberof SubmissionResultReadWithOutput
     */
    review?: ReviewDecision | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadWithOutput
     */
    reviewed_by?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResultReadWithOutput
     */
    reviewed_at?: Date | null;
}



/**
 * Check if a given object implements the SubmissionResultReadWithOutput interface.
 */
export function instanceOfSubmissionResultReadWithOutput(value: object): value is SubmissionResultReadWithOutput {
    if (!('submission_id' in value) || value['submission_id'] === undefined) return false;
    if (!('test_case_id' in value) || value['test_case_id'] === undefined) return false;
    if (!('output_text' in value) || value['output_text'] === undefined) return false;
    if (!('output_image_base64' in value) || value['output_image_base64'] === undefined) return false;
    if (!('diff_image_base64' in value) || value['diff_image_base64'] === undefined) return false;
    if (!('error_text' in value) || value['error_text'] === undefined) return false;
    return true;
}

export function SubmissionResultReadWithOutputFromJSON(json: any): SubmissionResultReadWithOutput {
    return SubmissionResultReadWithOutputFromJSONTyped(json, false);
}

export function SubmissionResultReadWithOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionResultReadWithOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'submission_id': json['submission_id'],
        'test_case_id': json['test_case_id'],
        'status': json['status'] == null ? undefined : SubmissionResultStatusFromJSON(json['status']),
        'points': json['points'] == null ? undefined : json['points'],
        'accepted_by': json['accepted_by'] == null ? undefined : AcceptedByFromJSON(json['accepted_by']),
        'near_match': json['near_match'] == null ? undefined : json['near_match'],
        'flagged_at': json['flagged_at'] == null ? undefined : (new Date(json['flagged_at'])),
        'flag_comment': json['flag_comment'] == null ? undefined : json['flag_comment'],
        'output_text': json['output_text'],
        'output_image_base64': json['output_image_base64'],
        'diff_image_base64': json['diff_image_base64'],
        'error_text': json['error_text'],
        'mismatch': json['mismatch'] == null ? undefined : json['mismatch'],
        'matched_output_id': json['matched_output_id'] == null ? undefined : json['matched_output_id'],
        'review': json['review'] == null ? undefined : ReviewDecisionFromJSON(json['review']),
        'reviewed_by': json['reviewed_by'] == null ? undefined : json['reviewed_by'],
        'reviewed_at': json['reviewed_at'] == null ? undefined : (new Date(json['reviewed_at'])),
    };
}

export function SubmissionResultReadWithOutputToJSON(json: any): SubmissionResultReadWithOutput {
    return SubmissionResultReadWithOutputToJSONTyped(json, false);
}

export function SubmissionResultReadWithOutputToJSONTyped(value?: SubmissionResultReadWithOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_id': value['submission_id'],
        'test_case_id': value['test_case_id'],
        'status': SubmissionResultStatusToJSON(value['status']),
        'points': value['points'],
        'accepted_by': AcceptedByToJSON(value['accepted_by']),
        'near_match': value['near_match'],
        'flagged_at': value['flagged_at'] == null ? undefined : ((value['flagged_at'] as any).toISOString()),
        'flag_comment': value['flag_comment'],
        'output_text': value['output_text'],
        'output_image_base64': value['output_image_base64'],
        'diff_image_base64': value['diff_image_base64'],
        'error_text': value['error_text'],
        'mismatch': value['mismatch'],
        'matched_output_id': value['matched_output_id'],
        'review': ReviewDecisionToJSON(value['review']),
        'reviewed_by': value['reviewed_by'],
        'reviewed_at': value['reviewed_at'] == null ? undefined : ((value['reviewed_at'] as any).toISOString()),
    };
}

